import React, { useMemo, useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from './ui/button';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import {
    Command,
    CommandInput,
    CommandList,
    CommandEmpty,
    CommandGroup,
    CommandItem,
} from './ui/command';

const MAX_RESULTS = 50;

export const ClientCombobox = ({ clients, value, onChange, placeholder = 'Seleziona cliente', testid }) => {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');

    const selected = useMemo(() => clients.find(c => c.id === value), [clients, value]);

    const results = useMemo(() => {
        const term = query.trim().toLowerCase();
        const base = term
            ? clients.filter(c =>
                (c.company_name || '').toLowerCase().includes(term) ||
                (c.country || '').toLowerCase().includes(term))
            : clients;
        return base.slice(0, MAX_RESULTS);
    }, [clients, query]);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    className="w-full justify-between font-normal"
                    data-testid={testid}
                >
                    <span className="truncate">{selected ? selected.company_name : placeholder}</span>
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="p-0 w-[--radix-popover-trigger-width]" align="start">
                <Command shouldFilter={false}>
                    <CommandInput placeholder="Cerca cliente..." value={query} onValueChange={setQuery} />
                    <CommandList>
                        <CommandEmpty>Nessun cliente trovato</CommandEmpty>
                        <CommandGroup>
                            {results.map(c => (
                                <CommandItem
                                    key={c.id}
                                    value={c.id}
                                    onSelect={() => { onChange(c.id); setOpen(false); }}
                                    data-testid={`client-option-${c.id}`}
                                >
                                    <Check className={cn('mr-2 h-4 w-4', value === c.id ? 'opacity-100' : 'opacity-0')} />
                                    <span className="truncate flex-1">{c.company_name}</span>
                                    {c.country && <span className="ml-2 text-xs text-muted-foreground shrink-0">{c.country}</span>}
                                </CommandItem>
                            ))}
                            {results.length >= MAX_RESULTS && (
                                <div className="px-3 py-2 text-xs text-muted-foreground">
                                    Troppi risultati: affina la ricerca…
                                </div>
                            )}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
};

export default ClientCombobox;
